import { render, staticRenderFns } from "./FundMapCompetitionDetails.vue?vue&type=template&id=2f394d7c&scoped=true"
import script from "./FundMapCompetitionDetails.vue?vue&type=script&lang=js"
export * from "./FundMapCompetitionDetails.vue?vue&type=script&lang=js"
import style0 from "./FundMapCompetitionDetails.vue?vue&type=style&index=0&id=2f394d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f394d7c",
  null
  
)

export default component.exports